<script lang="ts">
    import FileDrop from "$lib/components/FileDrop.svelte";
    import {fromBytes} from "$lib/utils/fileSizeConverter"
    import {storeFiles} from "$lib/calls/files";
    import {CloseButton, Heading, Input, Label, Textarea} from "flowbite-svelte";
    import ProjectDocuments from "$lib/components/ProjectDocuments.svelte";
    import RemoveButton from "$lib/components/ui/RemoveButton.svelte";

    export let project;

    export let files = [];


    const handleFiles = async (ok, rejected) => {
        files = [...files, ...ok];
        if(rejected.length>0){
            alert('Datei hat falsches Format oder ist zu groß')
        } else {
            //await storeFiles(ok)
        }
    }

</script>
<div class="space-y-12">
    <div class="">
        <h3 class="mt-7 leading-3 border-b border-neutral-300 pb-2">Optionale Angaben</h3>

        <Label class="space-y-2 mt-3">
            <span>Notiz / Hinweis</span>
            <Textarea bind:value={project.notes} />
        </Label>

        <Label class="space-y-2 mt-3">
            <span>Dokumente</span>
        </Label>
        {#if files.length > 0}
            <ul role="list" class="mt-5 divide-y divide-gray-100 rounded-md border border-gray-200">
                {#each files as file}
                    <li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">
                        <div class="flex w-0 flex-1 items-center">
                            <svg class="h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd"></path>
                            </svg>
                            <div class="ml-4 flex min-w-0 flex-1 gap-2">
                                <span class="truncate font-medium">{file.name}</span>
                            </div>
                        </div>
                        <div class="ml-4 flex-shrink-0">
                            <span class="flex-shrink-0 text-gray-400">{fromBytes(file.size)}</span>
                        </div>

                        <div class="ml-4 flex-shrink-0">
                            <RemoveButton value={file} onClick={(value) => {files = files.filter(x => x !== value)}} />
                        </div>
                    </li>
                {/each}
            </ul>
        {/if}
        <FileDrop allowedSize="4MB" extract={handleFiles} />
    </div>
</div>